<template>
    <div class="wrapper">
        <h2>Mobile settings</h2>

        <section>
            <h4>Info Text</h4>
            <div class="row">
                <custom-input name="infoTextBackgroundColor" ref="infoTextBackgroundColor" label="Background color" type="colorpicker" v-model="settings.infoTextBackgroundColor"/>
                <help-popover>
                    <template slot="content">
                        <p>The background color of the info messages</p>
                    </template>
                </help-popover>
            </div>
        </section>


    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import customInput from '@/components/additional/customInput.vue';
import HelpPopover from '../../additional/helpPopover';

export default {
    name: 'appearanceMobile',
    mixins: [
        Default
    ],
    components: { HelpPopover, customInput },
    props: ['settings']
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
